/**
 * The style guide's layers that link text can sit on, per mode (ADR-027 / round 12 #727: a brand profile
 * repaints the interactive colour and the status fills, never the layers, so `--interactive-text` from a
 * profile lands on these exact grounds). The values are src/index.css's `:root` and `.dark` blocks and
 * styles/contrast.test.ts asserts they match, so the brand mapper checks against what ships without
 * reading the stylesheet (PR #107 round 10: a profile's action colour cleared the page at 5.17:1 and failed
 * the soft tint at 4.29:1 — the one ground that was never checked).
 */
export const LINK_GROUNDS: Record<'light' | 'dark', Readonly<Record<string, string>>> = {
  light: { '--background': '#f2f3f9', '--muted': '#eef0f6', '--paper-2': '#e8ebf0', '--soft': '#e7e9fb', '--interactive-soft': '#e7e9fb', '--raised': '#e7e9fb' },
  dark: { '--background': '#061d21', '--muted': '#123e44', '--paper-2': '#17434a', '--soft': '#1c2c5e', '--interactive-soft': '#1c2c5e', '--raised': '#154750' },
};
